<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_software_category</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="ソフトウェアカテゴリ"></title-and-search>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 530px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
             件数<input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
            <br>
            <button :disabled="false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;" >出力</button>
            <button :disabled="selected_row == -1" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">抹消</button>
            <button :disabled="false" class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="addNew">新規</button>
          </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_master_software_category';
import { utils } from '@/libs/utils';


import _debug from 'debug';
var mdebug = _debug('esma:master_user');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      api_name:"master_software_category",
      page_acl: acl.generic,
      detail_page:"page_0041_master_software_category_detail",
      execute_filter_on_back:true
    };
  },
  computed: {
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.category, {}),
        utils.extend(fields.category_name, {}),
      ];
    }
  },
  methods: {
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    onDelete(){
      if(this.selected_row > -1){
        return this.$router.push({ name: this.detail_page, params: {  seq_id:this.selected_row,cmd:"delete"} });
      }
    },
    onEdit(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:this.selected_row,cmd:"edit"} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true})
    },
    onRowSelected(ev){
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource();
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0041_master_software_category.vue?31e02d34